import { useEffect, useState } from "react";
import { scrollToId } from "@/lib/attribution";
import { ASSETS } from "@/data/content";

const DEFAULT_LINKS = [
  { label: "LEARN", id: "learn" },
  { label: "HOST", id: "host" },
  { label: "FAQ", id: "faq" },
];

export default function Nav({ links = DEFAULT_LINKS, ctaLabel = "REGISTER ↗", ctaTarget = "register" }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 500);
    return () => clearTimeout(t);
  }, []);

  return (
    <nav
      data-testid="floating-nav"
      className={`fixed top-5 left-1/2 -translate-x-1/2 z-50 flex items-center gap-1 rounded-full px-2 py-1.5 nav-glass transition-all duration-700 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-3"
      }`}
    >
      <span className="flex items-center bg-white rounded-full px-3 py-1.5 mr-1" data-testid="nav-logo">
        <img src={ASSETS.logo} alt="Loan Factory" className="h-4 w-auto" />
      </span>
      {links.map((l) => (
        <button
          key={l.id}
          data-testid={`nav-link-${l.id}`}
          onClick={() => scrollToId(l.id)}
          className="hidden sm:block px-4 py-2 text-[11px] tracking-[0.18em] font-mono text-white/60 hover:text-white transition-colors"
        >
          {l.label}
        </button>
      ))}
      <button
        data-testid="nav-register-btn"
        onClick={() => scrollToId(ctaTarget)}
        className="ml-1 px-5 py-2 rounded-full btn-primary text-black text-[11px] font-bold tracking-[0.14em] font-mono"
      >
        {ctaLabel}
      </button>
    </nav>
  );
}
